module.exports = __webpack_public_path__ + "img/win-fullscreen.5d09f121.svg";